import React from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = ({ data }) => {
  let yearArr = [];
  let energyArr = [];
  let environmentArr = [];
  let technologyArr = [];
  data.forEach((val) => {
    try {
      const date = new Date(val.published);
      const year = date.getFullYear();
      if (!isNaN(year) && !yearArr.includes(year)) {
        yearArr.push(year);
      }
    } catch (error) {
      console.error("Error processing date:", error);
    }
  });
  
  yearArr.forEach((year) => {
    let countEnergy = 0;
    let countEnvironment = 0;
    let countTechnology = 0;

    data.forEach((val) => {
      const date = new Date(val.published);
      const postYear = date.getFullYear();
      const sector = val.sector.trim().toLowerCase(); // Convert to lowercase and trim whitespace

      if (postYear === year) {
        if (sector.includes("energy")) {
          countEnergy++;
        } else if (sector.includes("environment")) {
          countEnvironment++;
        } else if (sector.includes("technology")) {
          countTechnology++;
        }
      }
    });

    energyArr.push(countEnergy);
    environmentArr.push(countEnvironment);
    technologyArr.push(countTechnology);
  });
  const chartOptions = {
    chart: {
      height: 328,
      type: "line",
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: true,
        top: 3,
        left: 2,
        blur: 4,
        opacity: 1,
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    series: [
      {
        name: "Energy",
        data: energyArr,
      },
      {
        name: "Environment",
        data: environmentArr,
      },
      {
        name: "Technology",
        data: technologyArr,
      },
    ],
    title: {
      text: "News Published",
      align: "left",
      offsetY: 25,
      offsetX: 20,
    },
    subtitle: {
      text: "During",
      offsetY: 55,
      offsetX: 20,
    },
    markers: {
      size: 6,
      strokeWidth: 0,
      hover: {
        size: 9,
      },
    },
    grid: {
      show: true,
      padding: {
        bottom: 0,
      },
    },
    labels: yearArr,
    xaxis: {
      tooltip: {
        enabled: false,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetY: -20,
    },
  };

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartOptions.series}
      type="line"
      height={280}
    />
  );
};
export default LineChart;